// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../assets/Colors";
import { fetchGet, fetchPost } from "../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTablev2 } from "../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../assets/config";
import { useNavigate, useParams } from "react-router-dom";

const MonitoringJurnal = ({}) => {
  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit")
  );

  const [search, setSearch] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    Menu: "PC",
  });
  const params = useParams();

  const mutationData = useMutation((param) => fetchGet("Accounting/All"));
  const KirimTrans = useMutation((formData) =>
    fetchPost("Accounting/Kirim", formData)
  );

  const [showModalEdit, setShowModalEdit] = useState(false);

  useEffect(() => {
    mutationData.mutate();
  }, [KirimTrans.status]);

  useEffect(() => {
    bisnisUnit.mutate();
    mutationData.mutate();
  }, []);

  const editOpener = (detail) => {
    // AccountingID format baru mengandung slash — harus jadi dash dulu, kalau tidak
    // URL pecah jadi banyak segmen dan route ":transid" tak cocok (halaman blank).
    navigate(
      "/accounting/transaction/jurnal/" + String(detail ?? "").replaceAll("/", "-")
    );
  };

  const kirim = (detail) => {
    KirimTrans.mutate({ AccountingID: detail });
  };

  const header = [
    { name: "Jurnal ID", key: "AccountingID", modifiers: "Text" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "Tanggal", key: "Tanggal", modifiers: "Date" },
    { name: "Status", key: "Status", modifiers: "Text" },
    { name: "Voucher", key: "Button", modifiers: "VoucherJurnal" },
  ];

  const navigate = useNavigate();

  const filterData = (event) => {
    const filtered = mutationData.data.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setdataUpkeep(filtered);
  };

  const ModalOpener = (detail) => {
    navigate("/accounting/transaction/jurnal");
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
      BisnisUnitID: param.bisnisUnitID,
      Menu: "PC",
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
      Menu: "PC",
      BisnisUnitID: param.bisnisUnitID,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {}

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  content-center ">
                <DynamicTablev2
                  data={mutationData.data}
                  header={header}
                  menuController={filterData}
                  name={"Nama"}
                  title={"Report Jurnal"}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonitoringJurnal;
